import { useEffect, useRef, useState } from 'react';
import { consoleWs } from '@/core/ws/ConsoleWsManager';
import type { TenantNotification } from '@/core/types/live';

export type NotificationCallback = (notification: TenantNotification) => void;

export function useTenantNotifications(
  token: string | null,
  onNotification?: NotificationCallback,
) {
  const [connectionState, setConnectionState] = useState<'connecting' | 'connected' | 'disconnected'>('disconnected');
  const onNotificationRef = useRef(onNotification);
  onNotificationRef.current = onNotification;

  useEffect(() => {
    if (!token) return;

    consoleWs.acquire(token);

    const unsubState = consoleWs.onStateChange((cs) => {
      setConnectionState(cs === 'reconnecting' ? 'disconnected' : cs);
    });

    const unsubMsg = consoleWs.onMessage((msg) => {
      if (msg.type === 'Notification') {
        onNotificationRef.current?.(msg.notification);
      }
    });

    return () => {
      unsubMsg();
      unsubState();
      consoleWs.release();
    };
  }, [token]);

  return { connectionState };
}
